import { render } from "./BaseLayout.vue?vue&type=template&id=20884c37"
import script from "./BaseLayout.vue?vue&type=script&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script